var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cart__totals"},[_c('table',{staticClass:"totals__table"},[_c('tr',[_c('td',{staticClass:"totals__label"},[_vm._v("Subtotal")]),_vm._v(" "),_c('td',{staticClass:"totals__amount"},[_vm._v("$"+_vm._s(_vm.subtotal))])])]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }